export default function getAscentStyleLabel(ascentStyle: "LEAD" | "TOPROPE" | "AUTO_BELAY") {
  switch (ascentStyle) {
    case "LEAD":
      return "Lead";
    case "TOPROPE":
      return "Toprope";
    case "AUTO_BELAY":
      return "Auto Belay";
  }
}
